// src/kunde/main.js — indgangspunkt for kunde-appen.
//
// To opgaver: gøre de funktioner tilgængelige som markup kalder via
// onclick, og derefter starte appen.
//
// Om window-listen nedenfor: skærmbillederne bygges som HTML-strenge med
// onclick="..." i. De attributter slås op på window, og et modul er ikke
// window. Listen er broen imellem de to. Når skærmbillederne på et
// tidspunkt bygges om, bør de i stedet bruge addEventListener — så kan
// hele denne fil skæres væk, og 'unsafe-inline' kan fjernes fra CSP'en.

import '../styles/kunde.css';

import { closeModal, initDialoger } from './ui.js';
import {
  aabnTilfoejMaskine, closeDrawer, doForgot, doLogin, doRegister, doSetPassword,
  handleAuthBtn, openDrawer, showPage, start, switchAuth, switchNav, switchTab,
  toggleAddCard, toggleTheme, vaelgVisning,
} from './kerne.js';
import {
  closeBatModal, openBatModal, saveBatImei, startBatScan, stopBatScan, toggleBatteryType,
} from './batteri.js';
import { addCustomMachine, confirmCrop, updateCrop, uploadMachineImage } from './billede.js';
import { deleteMachine, gemNytNavn, omdoebMaskine, openMachinePage, renderMachines,
  toggleKontakt } from './maskiner.js';
import {
  addMachineFromSearch, addMachineFromSearchQr, liveSearch, liveSearchQr,
  selectProduct, selectProductQr,
} from './produkter.js';
import { triggerInstall } from './pwa.js';
import { scanQrFromImage, startScan, stopScan } from './scanner.js';
import { handleSticker, saveService, showSvcModal, toggleDP } from './service.js';
import { showMachineVideos } from './videoer.js';

// Den gamle service worker afregistreres og cachen ryddes. Appen kørte
// tidligere med en cache-first service worker, der kunne holde brugerne
// fast på en forældet version.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then(regs => regs.forEach(reg => reg.unregister()));
  if ('caches' in window) {
    caches.keys().then(keys => keys.forEach(k => caches.delete(k)));
  }
}

Object.assign(window, {
  // Fælles
  closeModal,
  // Skal, login og navigation
  aabnTilfoejMaskine, closeDrawer, doForgot, doLogin, doRegister, doSetPassword,
  handleAuthBtn, openDrawer, showPage, switchAuth, switchNav, switchTab,
  toggleAddCard, toggleTheme, vaelgVisning,
  // Batteri
  closeBatModal, openBatModal, saveBatImei, startBatScan, stopBatScan, toggleBatteryType,
  // Billede og oprettelse
  addCustomMachine, confirmCrop, updateCrop, uploadMachineImage,
  // Maskiner
  deleteMachine, gemNytNavn, omdoebMaskine, openMachinePage, renderMachines,
  toggleKontakt,
  // Produktsøgning
  addMachineFromSearch, addMachineFromSearchQr, liveSearch, liveSearchQr,
  selectProduct, selectProductQr,
  // Scanner
  scanQrFromImage, startScan, stopScan,
  // Service
  handleSticker, saveService, showSvcModal, toggleDP,
  // Øvrigt
  showMachineVideos, triggerInstall,
});

initDialoger();
start();
